import { Button } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

const Heading = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Cera Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #282828;
`;

const Footer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 16px;
`;

const CancelButton = styled(Button)`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 13px;

  width: 82px;
  height: 38px;

  background: #ffffff;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #6a6a6a;
`;

const ConfirmDeleteButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 17px;

  width: 153px;
  height: 38px;
  background: #ee4e4e;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;

const MainContent = styled.div`
  padding: 24px;
  display: flex;
  gap: 12px;
  flex: 1;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const InputLabel = styled.span`
  color: var(--cool-gray-500, #0d283b);

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export default {
  ConfirmDeleteButton,
  CancelButton,
  Footer,
  Container,
  Content,
  Heading,
  Header,
  MainContent,
  Column,
  InputLabel,
};
